import api from '../api/api';

// 保存当前菜单栏的路径
export const savePath = (state, pathName) => {
  state.pathName = pathName;
};
 
// 保存当前点击的数据源
export const saveCurrDbSource = (state, currDbSource) => {
  state.currDbSource = currDbSource;
};
 
// 保存当前点击的元数据
export const saveCurrJobData = (state, currJobData) => {
  state.currJobData = null;
  state.currJobData = currJobData;
};
 
// 保存所有数据源
export const saveDbSource = (state, DbSource) => {
  state.DbSource = DbSource;
};
 
// 保存搜索后选择的那一条元数据
export const saveSelectJobMeta = (state, selectJobMeta) => {
  state.selectJobMeta = selectJobMeta;
};
 
// 保存搜索的那一类专题
export const saveSpecialSubject = (state, specialSubject) => {
  state.specialSubject = specialSubject;
  state.selectJobMeta = {};
};
 
// 保存复制的元数据（名称为空）
export const saveDuplicateJobMeta = (state, duplicateJobMeta) => {
  state.duplicateJobMeta = duplicateJobMeta;
};

export const setLang = (state, lang) => {
	// state.lang = lang;
	state.lang = 'en';
};

export const setphLogoImage= (state, value) => {
    state.phLogoImage = 'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/ec97fcdb1bb2d7348f61baddbbb2f061.png';
};

export const setthemeColor= (state, value) => {
    state.themeColor = '#e62129';
};
export const setthemeArrow= (state, value) => {
    state.arrowIcon = value;
};
export const setnav_text_color= (state, value) => {
	state.nav_text_color = value;
};
export const setBrand= (state, value) => {
    state.brand = 'woodpecker';
};
export const saveCompareAttrs = (state, value) => {
    state.compare.attrs = value;
};

export const saveCompareProducts = (state, value) => {
    state.compare.products = value;
};

export const setCompareCategoryId = (state, id) => {
    state.compare.category_id = id;
};

